import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Avatar, Col, Form, Input, Row } from 'antd';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import {
  editSocialMediaChannels,
  getAllSocialMediaChannels,
} from 'redux/centres/actions';
import { useParams } from 'react-router';
import { SOCIAL_MEDIA_CHANNEL_TYPE } from 'configs/localData/constant';
import { validateRegex } from 'utils/validateUtils';
import CentreModal from '.';

const SocialMediaChannelsModal = forwardRef(
  ({ socialMedialChannelsList }, ref) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { id: centreId } = useParams();

    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState();

    useImperativeHandle(
      ref,
      () => ({
        open: (initialValue) => {
          setVisible(true);
          form.setFieldsValue(initialValue);
        },
      }),
      [form],
    );

    const handleCancel = () => {
      setVisible(false);
      form.resetFields();
    };

    const onOk = () => {
      form.validateFields().then((values) => {
        setLoading(true);
        dispatch(
          editSocialMediaChannels({
            centreId,
            data: values,
          }),
        )
          .then(({ payload }) => {
            if (payload?.isSuccess) {
              dispatch(
                getAllSocialMediaChannels({
                  centreId,
                  type: SOCIAL_MEDIA_CHANNEL_TYPE,
                }),
              );
              handleCancel();
            }
          })
          .finally(() => {
            setLoading(false);
          });
      });
    };

    return (
      <CentreModal
        title="centreDetail.socialMediaChannels"
        visible={visible}
        onCancel={handleCancel}
        onOk={onOk}
        loading={loading}
      >
        <Form form={form}>
          {socialMedialChannelsList?.map((item, index) => (
            <Row align="middle" className="p-0 m-0" key={Number(index)}>
              <Col span={5} className="flex items-center">
                <Avatar src={item?.icon} size={20} />
                <span className="ml-6">{item?.name}</span>
              </Col>
              <Col span={19} className="mt-16">
                <Form.Item
                  name={item?.id}
                  initialValue={item?.externalLink}
                  rules={[
                    {
                      pattern: validateRegex.link,
                      message: i18next.t('error.link'),
                    },
                  ]}
                >
                  <Input
                    placeholder={i18next.t('centreDetail.insertLink')}
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
          ))}
        </Form>
      </CentreModal>
    );
  },
);

SocialMediaChannelsModal.propTypes = {
  socialMedialChannelsList: PropTypes.array,
};

export default SocialMediaChannelsModal;
